(function() {

    'use strict';

    var TimeTravelerHelpCmp = {
        controllerAs: '$ctrl',
        templateUrl: 'time-traveler-help.component.html',
        controller: timeTravelerHelpCmpCtrl
    };
    
    angular.module('itxApp.common')
        .component('timeTravelerHelp', TimeTravelerHelpCmp);

    timeTravelerHelpCmpCtrl.$inject = ['itxAkamaiSvc','ItxConfigurationSvc'];

    function timeTravelerHelpCmpCtrl(itxAkamaiSvc,ItxConfigurationSvc) {
        var _this = this;
        _this.timeTraveler = {};
        _this.timeTraveler.show = false;
        if(ItxConfigurationSvc.isDebugActive()){
            _this.timeTraveler.show = ItxConfigurationSvc.getDebugOptions().timeTraveler;
        }

        itxAkamaiSvc.getDate().then(function() {
            var date = inditex.getLocalStorage( 'time_traveler' );
             
            if(date){
                date = moment(date, 'YYYY-MM-DDTHH:mm:ss');
                _this.timeTraveler.date = new Date(date);
                _this.timeTraveler.time = new Date(date);
                _this.timeTraveler.show = true;
            }
        });
        
        this.submitTimeTraveler = function() {
            var time = moment( this.timeTraveler.time ).format('HH:mm:ss');
            var date = moment( this.timeTraveler.date ).format('YYYY-MM-DD');
            inditex.setLocalStorage( 'time_traveler', date + 'T' + time );
            setTimeTraveler(true, {date: date, time: time});
        };

        this.closeTimeTraveler = function() {
            inditex.removeLocalStorage('time_traveler');
            setTimeTraveler(false);
        };

        function setTimeTraveler(active, obj) {
            var hash =  window.location.hash ? window.location.hash : '' ;
            var path = window.location.protocol + '//' + window.location.host + window.location.pathname;
            var url;

            if (active) {
                var paramTravel = '?time_traveler=' + obj.date + 'T' + obj.time;
                url = path + paramTravel + hash;
            } else {
                url = path + hash;
            }
            
            window.location.href = url;
        }

    }

})();